import React, { useState } from "react";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CreateIcon from "@material-ui/icons/Create";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import InboxIcon from "@material-ui/icons/Inbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import AppsIcon from "@material-ui/icons/Apps";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';

import SidebarOption from "../SidebarOption/SidebarOption";
import { auth } from "../../services/firebase";
import {
  MenuIconContainer,
  SidebarContainer,
  SidebarHeader,
  SidebarInfo,
} from "./Sidebar.elements";
import Loading from "../Loading/Loading";
import useRooms from "../../hooks/use-rooms";

function Sidebar() {
  const {rooms, isLoading} = useRooms();
  let initialState = false;

  if(window.innerWidth > 1000) {
    initialState = true;
  }
  
  const [showSidebar, setShowSidebar] = useState(initialState);

  const toggleSidebar = () => {
    if(window.innerWidth < 1000) {
      setShowSidebar((prevState) => !prevState);
    } else {
      return;
    }
  }

  return (
    <>
    <MenuIconContainer onClick={toggleSidebar}>
      {!showSidebar && <MenuIcon />}
      {showSidebar && <CloseIcon />}
    </MenuIconContainer>
    {showSidebar && <SidebarContainer>
      <SidebarHeader>
        <SidebarInfo>
          <h2>SLACK CLONE HQ</h2>
          <h3>
            <FiberManualRecordIcon /> {auth.currentUser?.displayName}
          </h3>
        </SidebarInfo>
        <CreateIcon />
      </SidebarHeader>
      <SidebarOption Icon={InsertCommentIcon} title="Threads" />
      <SidebarOption Icon={InboxIcon} title="Mentions & reactions" />
      <SidebarOption Icon={DraftsIcon} title="Saved items" />
      <SidebarOption Icon={BookmarkBorderIcon} title="Channel browser" />
      <SidebarOption Icon={PeopleAltIcon} title="People & user groups" />
      <SidebarOption Icon={AppsIcon} title="Apps" />
      <SidebarOption Icon={FileCopyIcon} title="File browser" />
      <SidebarOption Icon={ExpandLessIcon} title="Show less" />
      <hr />
      <SidebarOption Icon={ExpandMoreIcon} title="Channels" />
      <hr />
      <SidebarOption Icon={AddIcon} title="Add Channel" addChannelOption toggleSidebar={toggleSidebar}/>
      {isLoading && <Loading />}
      {rooms.map((room) => {
        return <SidebarOption key={room.id} id={room.id} title={room.name}  toggleSidebar={toggleSidebar} />;
      })}
    </SidebarContainer>}
    </>
  );
}

export default Sidebar;
